/*Package importing*/
import React, { Component } from 'react';
import $ from 'jquery';
import 'react-dates/initialize';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';


/*Components*/
import DateRange from '../../components/dateRangePicker/dateRange.js';
import SelectBox from '../../components/formComponents/selectBox';
import Input from '../../components/formComponents/input.js';


import devconfig from '../../config/config.js';
import APIPost from '../../services/apiCall/post';
import APIGet from '../../services/apiCall/get';

/*Assets*/
import sampleBanner from '../../assets/images/sample-banner.jpg';


class ViewAdContentModal extends Component {
  constructor(props){
    super(props);
    this.state = {
      data: null,
      title: "",
      discount: "",
      start_date: "",
      end_date: "",
      category_ids: [],
      sub_category_ids: [],
      product_ids :[],
      dateFilter: false,
      initalDate: moment().format(),
      startDate: moment().startOf('month'),
      endDate: moment(),
      categoryOptions: [],
      subCategoryOptions: [],
      productOptions: [],
      departmentData: null

    }
  }

  componentDidMount() {
    this.getCategoryList();
    if(localStorage.getItem("vendor_data") && JSON.parse(localStorage.getItem("vendor_data")).seller_type>1){
      this.setState({localVendor: true});
    }  
  }

  getCategoryList(){
    var url = devconfig.vendor+'auth/profile';
    APIGet(url).then(function(response){
      if(response.status==="ok" && localStorage.getItem("vendor_data") && JSON.parse(localStorage.getItem("vendor_data")).seller_type ==1){
        var catData = response.data.category_data;
        var tempArray = [];
        for (var j = 0; j <= catData.length - 1; j++) {
          var item = catData[j]
          tempArray.push({value: item.id, label: item.category});
        }
        this.setState({categoryOptions: tempArray});
      }
      else if(response.status==="ok" && localStorage.getItem("vendor_data") && JSON.parse(localStorage.getItem("vendor_data")).seller_type>1){
        var catData = response.data.category_data;
        var tempArray = [];
        for (var j = 0; j <= catData.length - 1; j++) {
          var item = catData[j]
          tempArray.push({value: item.id, label: item.department});
        }
        this.setState({categoryOptions: tempArray, departmentData: response.data.category_data});
      }
    }.bind(this))
  }
 
  categoryChange = async (category) =>{
    await this.setState({category: category});
    if(this.state.localVendor){
      let temp = this.state.departmentData;
      temp.forEach(department =>{
        if(department.id == category.value){
          var catData = department.category	;
          var tempArray = [];
          for (var j = 0; j <= catData.length - 1; j++) {
            var item = catData[j]
            tempArray.push({value: item.id, label: item.category});
          }
          this.setState({subCategoryOptions: tempArray, categoryData:  department.category});
        }
      })
    }
    else{
      this.subCategory([category.value]);
    }
    // console.log("hiiiiii")
  }

  subCategoryChange = async (sub_category) => {
    await this.setState({sub_category: sub_category});
    if(this.state.localVendor){
      let temp = this.state.categoryData;
      temp.forEach(category =>{
        if(category.id == sub_category.value){
          var catData = category.sub_category	;
          var tempArray = [];
          for (var j = 0; j <= catData.length - 1; j++) {
            var item = catData[j]
            tempArray.push({value: item.id, label: item.sub_category});
          }
          this.setState({productOptions: tempArray});
        }
      })
    }
    else{
      this.product([sub_category.value]);
    }
  }
  productChange = async (product) => {
    await this.setState({product: product});
  }

  subCategory(category_ids){
    this.setState({apiLoading: true});
    var url = devconfig.vendor+'subcategory/list';
    var data = JSON.stringify({
      "category_ids": category_ids
    })
    APIPost(url, data).then(function(response){
      if(response.status==="ok"){
        var catData = response.data;
        var tempArray = [];
        for (var j = 0; j <= catData.length - 1; j++) {
          var item = catData[j]
          tempArray.push({value: item.id, label: item.sub_category});
        }
        this.setState({subCategoryOptions: tempArray});
      }
    }.bind(this))
  }


  product(sub_category_ids){
    // console.log("hiii");
    var url = devconfig.vendor+'product/list';
    var data = JSON.stringify({
      "sub_category_ids": sub_category_ids
    })
     APIPost(url, data).then(function(response){
      if(response.status==="ok"){
        var catData = response.data;
        var tempArray = [];
        for (var j = 0; j <= catData.length - 1; j++) {
          var item = catData[j]
          tempArray.push({value: item.id, label: item.product});
        }
        this.setState({productOptions: tempArray});
      }
    }.bind(this))
  }


  async createOffer(e){
    // console.log(this.state.category);
    // console.log(this.state.sub_category);
    // console.log(this.state.product);

    e.preventDefault();
    this.setState({apiLoading: true});
    var url = devconfig.vendor+'offer/create';
    var data = JSON.stringify({
      "title": this.state.title,
      "offer_link": this.state.link,
      "start_date": this.state.tempStart,
      "end_date": this.state.tempEnd,
      "category_id": this.state.category.value,
      "sub_category_ids": [this.state.sub_category.value],
      "product_ids":[this.state.product.value],
      "discount":this.state.discount
    });
    if(localStorage.getItem("vendor_data") && JSON.parse(localStorage.getItem("vendor_data")).seller_type>1){
      data = JSON.stringify({
        "title": this.state.title,
        "offer_link": this.state.link,
        "start_date": this.state.tempStart,
        "end_date": this.state.tempEnd,
        "department_id": this.state.category.value,
        "category_ids": [this.state.sub_category.value],
        "sub_category_ids":[this.state.product.value],
        "discount":this.state.discount
      });
    }
    await APIPost(url,data).then(function(response){
      if(response.status == "ok"){
        $("#adDetailModal").modal('hide');
        window.location.reload(true);
      }
    }.bind(this))
  }

   dateChange(tempStart, tempEnd){
    this.setState({tempStart,tempEnd});
    var url = devconfig.vendor+'offer/create';
    var data = JSON.stringify({
      "start_date": tempStart,
      "end_date": tempEnd
    })
     APIPost(url,data).then(function(response){
      if(response.status == "ok"){
         this.setState({ data: response.data});
      }
    }.bind(this))

  }
  valueChangeHeading(value){
    this.setState({title: value});
  }
  valueChangeDiscount(value){
     this.setState({discount: value});
  }

  render() {

    const filterBy = [
      { value: 1, label: 'Active' },
      { value: 2, label: 'Ongoing' },
      { value: 3, label: 'Completed' },
    ]

    return (
      <div className="modal fade e-ad-detail-wrap e-ofer-modal" id="adDetailModal" tabIndex="-1" role="dialog" aria-labelledby="adDetailModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered"  role="document">
          <div className="modal-content e-ofer">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <h6 className="e-modal-header">Create offers</h6>
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-lg-12">
               <Input id={this.props.id} value="" type="text" className="e-add-career" valueChange={this.valueChangeHeading.bind(this)} placeholder="Offer heading"/>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
               <Input  value="" type="text" className="e-add-career" valueChange={(e) => this.setState({link: e})} placeholder="Offer Link"/>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12"> 
               <DateRange dateChange={this.dateChange.bind(this)} isOutsideRange={false}/>
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-lg-6">
               <SelectBox defaultValue={this.state.filterDefault}  options={this.state.categoryOptions} selectchange={this.categoryChange} placeholder="Select categories"/>
              </div>

              <div className="col-lg-6">
               <SelectBox defaultValue={this.state.filterDefault}  options={this.state.subCategoryOptions} selectchange={this.subCategoryChange} placeholder="Select subcategories"/>
              </div>
            </div>
             <div className="row mt-2">
              <div className="col-lg-6">
               <SelectBox defaultValue={this.state.filterDefault} options={this.state.productOptions} selectchange={this.productChange} placeholder="Select items"/>
              </div>

              <div className="col-lg-6 mt-1">
                <Input id={this.props.id} value="" type="text" className="e-add-career" valueChange={this.valueChangeDiscount.bind(this)} placeholder="Enter offer"/>
              </div>
            </div>
            <div className="d-flex w-100 align-items-center justify-content-end">
                <a href="#" className="float-right pt-4 e-ofer-cancel" data-dismiss="modal">Cancel</a>
              {
                this.state.title && this.state.tempStart && this.state.tempEnd && this.state.category && this.state.product && this.state.sub_category && this.state.discount && this.state.link ?

                <button className="e-s-btn e-new-ofer position-relative mt-3 ml-5" type="submit" value="Submit" onClick={this.createOffer.bind(this)}>Create</button>
                :
                 <button className="e-s-btn e-inactive e-new-ofer position-relative mt-3 ml-5" type="submit" value="Submit">Create</button>
              }

            </div>

            <div className="modal-footer">


              {/*

              <span className="e-s-link-txt mr-4" data-dismiss="modal">Cancel</span>
              {
                this.state.category && this.state.styleType && this.state.colorOne.length && this.state.colorTwo.length  ?
                  <button type="submit" className="e-s-btn" value="Submit" data-dismiss="modal" onClick={this.submit.bind(this)}>Submit</button>
                :
                  <button type="submit" className="e-s-btn e-inactive" value="Submit" >Submit</button>
              }

            */}

            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ViewAdContentModal;
